const BuyGroupIndex= () =>import('@/components/buygroup/BuyGroupIndex')
const BuyGroupOrderList= () =>import('@/components/buygroup/BuyGroupOrderList')
const BuyGroupOrder= () =>import('@/components/buygroup/BuyGroupOrder')
// const PaySuccess= () =>import('@/components/buygroup/PaySuccess')
// const BuyGroupOrderShare= () =>import('@/components/buygroup/BuyGroupOrderShare')
const LoginBottom= () =>import('@/components/base/LoginBottom')
export default[
        {
            path: '/buygroup/index',
            component: BuyGroupIndex,
            meta: {title: '加载中'}
        },
    {
        path: '/buygroup/orderlist',
        component: BuyGroupOrderList,
        meta: {title: '加载中'}
    },
    {
        path: '/buygroup/order',
        component: BuyGroupOrder,
        meta: {title: '加载中'}
    },
    {
        path: '/buygroup/pay_success',
        component: BuyGroupOrder,
        meta: {title: '加载中'}
    },
    {
        path: '/buygroup/share',
        component: BuyGroupOrder,
        meta: {title: '加载中'}
    },
    {
        path: '/buygroup/login',
        component: LoginBottom,
        meta: {title: '加载中'}
    }
]




// WEBPACK FOOTER //
// ./src/router/buyGroupRouter.js